var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"fill-current inline-block",class:_vm.size?`w-${_vm.size} h-${_vm.size}`:`w-6 h-6`,attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","fill":"currentColor"}},[_c('path',{attrs:{"d":"M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }